const questions = [
    {
      "id": 1,
      "wordA": "白鳥の湖",
      "wordB": "百鳥の湖",
      "answer": 1
    },
    {
      "id": 2,
      "wordA": "十年一昔",
      "wordB": "十年一音",
      "answer": 1
    },
    {
      "id": 3,
      "wordA": "みかづき",
      "wordB": "みづかき",
      "answer": 2
    },
    {
      "id": 4,
      "wordA": "クレヨン",
      "wordB": "クレヨン",
      "answer": 0
    },
    {
      "id": 5,
      "wordA": "3618",
      "wordB": "3613",
      "answer": 1
    },
    {
      "id": 6,
      "wordA": "BOOK",
      "wordB": "BOOT",
      "answer": 1
    },
    {
      "id": 7,
      "wordA": "￥379",
      "wordB": "￥379",
      "answer": 0
    },
    {
      "id": 8,
      "wordA": "演奏旅行",
      "wordB": "演奏旅行",
      "answer": 0
    },
    {
      "id": 9,
      "wordA": "はこべら",
      "wordB": "はこべろ",
      "answer": 1
    },
    {
      "id": 10,
      "wordA": "ニュース",
      "wordB": "ニコース",
      "answer": 1
    },
    {
      "id": 11,
      "wordA": "5892",
      "wordB": "5892",
      "answer": 0
    },
    {
      "id": 12,
      "wordA": "JOCX",
      "wordB": "JOCX",
      "answer": 0
    },
    {
      "id": 13,
      "wordA": "岩のがけ",
      "wordB": "岩のかげ",
      "answer": 2
    },
    {
      "id": 14,
      "wordA": "右折禁止",
      "wordB": "左折禁止",
      "answer": 1
    },
    {
      "id": 15,
      "wordA": "きあげは",
      "wordB": "きあげは",
      "answer": 0
    },
    {
      "id": 16,
      "wordA": "シロップ",
      "wordB": "ツロㇱプ",
      "answer": 2
    },
    {
      "id": 17,
      "wordA": "3468",
      "wordB": "3486",
      "answer": 2
    },
    {
      "id": 18,
      "wordA": "YWCA",
      "wordB": "YMCB",
      "answer": 2
    },
    {
      "id": 19,
      "wordA": "27854cm",
      "wordB": "27854mm",
      "answer": 1
    },
    {
      "id": 20,
      "wordA": "株式売買報告",
      "wordB": "株式買売報告",
      "answer": 2
    },
    {
      "id": 21,
      "wordA": "とうりゃんせ",
      "wordB": "とおりゃんせ",
      "answer": 1
    },
    {
      "id": 22,
      "wordA": "ダイヤモンド",
      "wordB": "ダイアモンド",
      "answer": 1
    },
    {
      "id": 23,
      "wordA": "473852",
      "wordB": "473852",
      "answer": 0
    },
    {
      "id": 24,
      "wordA": "flower",
      "wordB": "flover",
      "answer": 1
    },
    {
      "id": 25,
      "wordA": "ラワン材輸入",
      "wordB": "ラワン材輪入",
      "answer": 1
    },
    {
      "id": 26,
      "wordA": "電信電話公社",
      "wordB": "電信電話公社",
      "answer": 0
    },
    {
      "id": 27,
      "wordA": "おはなばたけ",
      "wordB": "おはなばたけ",
      "answer": 0
    },
    {
      "id": 28,
      "wordA": "バターロール",
      "wordB": "パトーロール",
      "answer": 2
    },
    {
      "id": 29,
      "wordA": "597384",
      "wordB": "592384",
      "answer": 1
    },
    {
      "id": 30,
      "wordA": "UNICEF",
      "wordB": "VNICET",
      "answer": 2
    },
    {
      "id": 31,
      "wordA": "24リットル",
      "wordB": "24リットル",
      "answer": 0
    },
    {
      "id": 32,
      "wordA": "会議決定結果",
      "wordB": "合議決定結果",
      "answer": 1
    },
    {
      "id": 33,
      "wordA": "おてらのかね",
      "wordB": "おてろのかぬ",
      "answer": 2
    },
    {
      "id": 34,
      "wordA": "オペラグラス",
      "wordB": "オペラクラス",
      "answer": 1
    },
    {
      "id": 35,
      "wordA": "756246",
      "wordB": "756346",
      "answer": 1
    },
    {
      "id": 36,
      "wordA": "Mt. Fuji",
      "wordB": "Mt. Fuji",
      "answer": 0
    },
    {
      "id": 37,
      "wordA": "サハラさばく",
      "wordB": "サハラさはぐ",
      "answer": 2
    },
    {
      "id": 38,
      "wordA": "自動車駐車場",
      "wordB": "自転車駐車場",
      "answer": 1
    },
    {
      "id": 39,
      "wordA": "おおむらさき",
      "wordB": "あおむらさき",
      "answer": 1
    },
    {
      "id": 40,
      "wordA": "アルキメデス",
      "wordB": "アルキメデス",
      "answer": 0
    },
    {
      "id": 41,
      "wordA": "889899",
      "wordB": "889989",
      "answer": 2
    },
    {
      "id": 42,
      "wordA": "ping pong",
      "wordB": "ping pomg",
      "answer": 1
    },
    {
      "id": 43,
      "wordA": "ラインのぶどう畑",
      "wordB": "ラインのぶどう畑",
      "answer": 0
    },
    {
      "id": 44,
      "wordA": "常用国語表記辞典",
      "wordB": "常用国語表記字典",
      "answer": 1
    },
    {
      "id": 45,
      "wordA": "ひびきわたるこえ",
      "wordB": "ひびきわたるこえ",
      "answer": 0
    },
    {
      "id": 46,
      "wordA": "スペースシャトル",
      "wordB": "スペースシャトル",
      "answer": 0
    },
    {
      "id": 47,
      "wordA": "14118112",
      "wordB": "14111812",
      "answer": 2
    },
    {
      "id": 48,
      "wordA": "BASEBALL",
      "wordB": "BASFBALL",
      "answer": 1
    },
    {
      "id": 49,
      "wordA": "紙パルプ製造過程",
      "wordB": "紙パルプ製造通程",
      "answer": 1
    },
    {
      "id": 50,
      "wordA": "人工衛星軌道計算",
      "wordB": "人工衛生軌道計質",
      "answer": 2
    },
    {
      "id": 51,
      "wordA": "おんどりめんどり",
      "wordB": "おんどうめんどう",
      "answer": 2
    },
    {
      "id": 52,
      "wordA": "エープリルフール",
      "wordB": "エープリルプール",
      "answer": 1
    },
    {
      "id": 53,
      "wordA": "11212212",
      "wordB": "11212112",
      "answer": 1
    },
    {
      "id": 54,
      "wordA": "telephone",
      "wordB": "telepbonc",
      "answer": 2
    },
    {
      "id": 55,
      "wordA": "金27196円也",
      "wordB": "全27196円他",
      "answer": 2
    },
    {
      "id": 56,
      "wordA": "交通安全強化月間",
      "wordB": "交通安全強化月間",
      "answer": 0
    },
    {
      "id": 57,
      "wordA": "あしながおじさん",
      "wordB": "あしながおばさん",
      "answer": 1
    },
    {
      "id": 58,
      "wordA": "フニクリフニクラ",
      "wordB": "フニクリクニクリ",
      "answer": 2
    },
    {
      "id": 59,
      "wordA": "53271964",
      "wordB": "53271964",
      "answer": 0
    },
    {
      "id": 60,
      "wordA": "Mississippi",
      "wordB": "Mississippi",
      "answer": 0
    },
    {
      "id": 61,
      "wordA": "ほたるの光窓の雪",
      "wordB": "ほたるの光空の雲",
      "answer": 2
    },
    {
      "id": 62,
      "wordA": "経済学部経営学科",
      "wordB": "径済学部経営学料",
      "answer": 2
    },
    {
      "id": 63,
      "wordA": "アインシュタイン",
      "wordB": "アインシュタイン",
      "answer": 0
    },
    {
      "id": 64,
      "wordA": "こんじゃくものがたり",
      "wordB": "こんじゃくものかたり",
      "answer": 1
    },
    {
      "id": 65,
      "wordA": "08F1F240FF",
      "wordB": "08F1F240FF",
      "answer": 0
    },
    {
      "id": 66,
      "wordA": "San Francisco",
      "wordB": "Sun Fransisco",
      "answer": 2
    },
    {
      "id": 67,
      "wordA": "百聞は一見にしかず",
      "wordB": "百聞は一見にしかず",
      "answer": 0
    },
    {
      "id": 68,
      "wordA": "ホップステップジャンプ",
      "wordB": "ホップスキップジャンプ",
      "answer": 1
    },
    {
      "id": 69,
      "wordA": "春眠不覚暁処処聞啼鳥",
      "wordB": "春眼不覚暁処処間啼鳥",
      "answer": 2
    },
    {
      "id": 70,
      "wordA": "microelectronics",
      "wordB": "microelecfronics",
      "answer": 1
    }
  ];

export default questions;